// import React from "react";
// import { useNavigate } from "react-router-dom";

// const DesktopLanding = () => {
//      const navigate = useNavigate()
//   return (
//     <>
//       <div className="h-[100vh] w-full bg-gradient-to-b from-[#253246] to-[#1e2738] text-white">
//         <nav className=" w-full flex items-center justify-around p-10 ">
//           <div>
//             <img src="./econet.png" alt="" className=" w-[15vw]" />
//           </div>
//           <div className="  flex flex-col  justify-center gap-5 font-semibold text-xl ">
//             <h1 className="text-7xl font-bold">Enter a new Reality</h1>
//             <h1>Unlimited Entertainment</h1>
//           </div>
//         </nav>

//         <div className=" flex p-10 justify-around">
//           <div className=" ">
//             <img className="py-5" src="YoGamesXR.png" alt="" />

//             <button className="bg-[#ffffff] px-8 py-3 rounded-md text-black text-2xl font-semibold my-10 w-[70%]" onClick={() => navigate("/login")}>
//            Login
//             </button>
//             <button className="border border-white px-8 py-3 rounded-md text-white text-2xl font-semibold my-10 w-[70%]" onClick={() => navigate("/subscribe")}>
//               Subscribe
//             </button>
//             <p className="text-xl py-5 font-thin my-10">
//               By <span className="font-semibold">continuing</span> , you have read, understood and agree to be bound <br /> by
//               the <span className="font-semibold">YoGamezXR</span> service’s <span className="font-semibold">Terms & Conditions and FAQ’s</span>
//             </p>
//           </div>
//           <div className="flex justify-center items-center">
//             <img src="./goggles.png" alt="" className="w-[35vw]" />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DesktopLanding;


import React from "react";
import { useNavigate } from "react-router-dom";

const DesktopLanding = () => {
  const navigate = useNavigate();
  return (
    <div className="h-[100vh] w-[100vw] bg-gradient-to-b from-[#253246] to-[#1e2738] flex justify-center items-center">
      <div className="h-[80vh] w-[80vw] text-white overflow-auto">
        <nav className="w-full flex items-center justify-around p-10">
          <div>
            <img src="./econet.png" alt="" className="w-[15vw]" />
          </div>
          <div className="flex flex-col justify-center gap-10 font-semibold text-xl">
            <h1 className="text-[4vw] font-bold p-2">Enter a new Reality</h1>
            <h1 className="text-[1.5vw] p-5 lg:p-10">Unlimited Entertainment</h1>
          </div>
        </nav>

        <div className="flex p-10 justify-around">
          <div>
            <img className="py-5 w-[20vw]" src="YoGamesXR.png" alt="" />
            <button className="bg-[#ffffff] px-8 py-3 rounded-md text-black text-[1.5vw] font-semibold my-5 w-[70%]" onClick={() => navigate("/login")}>
              Login
            </button>
            <button className="border border-white px-8 py-3 rounded-md text-white text-[1.5vw] font-semibold my-5 w-[70%]" onClick={() => navigate("/subscribe")}>
              Subscribe
            </button>
            <p className="text-[1vw] py-5 font-thin">
              By <span className="font-semibold">continuing</span>, you have read, understood and agree to be bound <br /> by the <span className="font-semibold">YoGamezXR</span> service's{" "}
              <span
                onClick={() => navigate("/termsandconditions")}
                className="underline text-cyan-400 hover:text-cyan-300 cursor-pointer font-semibold"
              >
                Terms & Conditions
              </span>{" "}
              and FAQ's
            </p>
          </div>
          <div className="flex justify-center items-center">
            <img src="./goggles.png" alt="" className="w-[35vw]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopLanding;